import { render, staticRenderFns } from "./RewardProgress.vue?vue&type=template&id=58aed97f&"
import script from "./RewardProgress.vue?vue&type=script&lang=js&"
export * from "./RewardProgress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports